import {connect} from 'react-redux'

import {ModalOfferDetailsEmp} from './ModalOfferDetailsEmp'

export const ModalOfferDetailsEmpContainer = connect(
  null,
  null
)(ModalOfferDetailsEmp)
